import { ChangeDetectionStrategy, Component, EventEmitter, inject, input, Output, signal, type WritableSignal } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { RouterService } from '@shared/services/router.service';
import { CHAT_PAGE_PATH } from 'src/app/bar/utils/constants';
import { AssistantChatData } from '../../../model';
import { ExperiencesService } from 'src/app/bar/services/experiences.service';
import { ChatsService } from '../../../services/chats.service';
import { HubService } from 'src/app/bar/services/hub.service';

@UntilDestroy()
@Component({
  selector: 'chat-sidebar-assistant-item',
  templateUrl: './chat-sidebar-assistant-item.component.html',
  styleUrls: ['./chat-sidebar-assistant-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatSidebarAssistantItem {
  private readonly ASSISTANTS_URL = '/admin/assistant/new/general';

  private routerService: RouterService = inject(RouterService);
  private assistantService: ExperiencesService = inject(ExperiencesService);
  private chatsService: ChatsService = inject(ChatsService);
  private hubService: HubService = inject(HubService);

  tooltipDisabled: WritableSignal<boolean> = signal(true);

  assistantItem = input<AssistantChatData>();
  isHeader = input<boolean>();
  isPinned = input<boolean>();
  isSmallScreen = input<boolean>();

  @Output() closeSidebar = new EventEmitter();
  @Output() sidebarPinnedState = new EventEmitter();

  private onAssistantSelect() {
    this.closeSidebar.emit(this.assistantItem());
  }

  openAssistantPage(event) {
    event.stopPropagation();
    this.assistantService.openAssistant(this.assistantItem().id);
  }

  navigateToNewChat() {
    this.onAssistantSelect();
    this.chatsService.forceStopChat$.next(true);
    const chatUrl = this.assistantItem()?.id ? `/${CHAT_PAGE_PATH}/${this.assistantItem().id}` : `/${CHAT_PAGE_PATH}`;
    this.routerService.navigateByUrl(chatUrl);
  }

  updateTooltip(element: HTMLElement) {
    this.tooltipDisabled.set(!(element.offsetWidth < element.scrollWidth));
  }

  openNewAssistantPageSettings() {
    this.hubService.openUrl(this.ASSISTANTS_URL);
  }

  setSidebarPinnedState(state) {
    this.sidebarPinnedState.emit(state);
  }
}
